import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getProviders : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/providers', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getProvider : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	createProvider : function({ commit }, data){
	
		return new Promise((resolve, reject) => {
			api.post('admin/providers', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	editProvider : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.patch('admin/providers/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},

	deleteProvider : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.delete('admin/providers/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		})
	},
	getPreferredLanguages : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/preferred-languages', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	getLanguages: function ({ commit }, data) {
		return new Promise((resolve, reject) => {
			api.get('admin/languages/',  data ).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	getProviderOrganizations : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id+'/organizations', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	getProviderOrganizationDetail : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id+'/organization-detail', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	editProviderOrganizationDetail : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/providers/'+data.id+'/organization-detail', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	restorePassword : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/providers/'+data.id+'/restore-pass', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	getProviderOrganizationCourse : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id+'/organization/' + data.organization_id + '/course/' + data.course_id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	providerBulkSMS : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/providers/bulk/sms', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	getProviderHistory : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id+'/history', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	getCannedMessages : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/templates', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	getStatusInOrganization : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/providers/status-organization', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	/*getProviderOrganizations : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/providers/'+data.id+'/organizations-detail', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	}*/

	getCustomMessages : function ({ commit }) {
		return new Promise((resolve, reject) => {
			api.get('admin/panel-messages', {}).then((res) => {
				resolve(res)
			}).catch((error) => {
				reject(error.response);
			});
		})
	},


	getProvidersV2 : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/providers/list', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getProvidersCountV2 : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/providers/list/count', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getProvidersSignUp : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/providers/sign-ups', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getProviderCompletedCourse : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/providers/completed-course', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	setPassword: function ({ commit }, data) {
		return new Promise((resolve, reject) => {
			api.post("reset-pass", {
					provider_id: data.filters.user_id,
					password: data.filters.password
		})
        .then(res => {
          resolve(res);
        })
		.catch(error => {
			reject(error);
        });
		})
	},
	setPasswordUser: function ({ commit }, data) {
		return new Promise((resolve, reject) => {
			api.post("reset-pass", {
					user_id: data.filters.user_id,
					password: data.filters.password
		})
        .then(res => {
          resolve(res);
        })
		.catch(error => {
			reject(error);
        });
		})
	},
	generatePassword: function ({ commit }) {
		return new Promise((resolve, reject) => {
			api.get('generate-password', {}).then((res) => {
				resolve(res)
			})
		})
	},
	simulateProgramCompletion({ commit }, data) {
		return new Promise((resolve, reject) => {
			api.post(`admin/fake/programs/${data.program_id}/complete`, data)
			.then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ProviderModule.js